/* file description */

import React, { CSSProperties, FC, forwardRef, HTMLAttributes, useEffect, useRef, useState } from 'react';
import { NodeOptions } from './components';
import { useScale } from './effects';

import styles from './index.module.less';

export const XSelectTree = forwardRef<any, any>(
  ({ value, onCheckedChange, renderNode, currentClickNode, handleNodeClick, checkedAble, scale}, ref) => {
    const {
      targetDomRef,
      scaleStyle
    } = useScale();
    
    const handleChange = () => {
      onCheckedChange &&
      onCheckedChange({
          ...(value || {}),
        });
    };

    return (
      <div className={styles['select-tree-wrap']} ref={targetDomRef} style={scale ? scaleStyle : undefined}>
        <NodeOptions
          currentClickNode={currentClickNode}
          handleNodeClick={handleNodeClick}
          renderNode={renderNode}
          value={value}
          onChange={handleChange}
          targetIndex={0}
          checkedAble={checkedAble}
        />
      </div>
    );
  },
);
